export default __webpack_public_path__ + "static/media/logo-big.3518bb96.png";